/**
 * Created by mooring on 7/1/15.
 */
import env from '../common/env.js';
import * as StringUtil from '../base/string.js';
import * as encrypt from '../base/encrypt.js';
import * as base from '../base/mbase.js';
import localstorage from '../base/localstorage.js';
import deepclone from '../base/deepclone.js';
import Dom from '../base/mdom.js';
let exportData;
if(!env.isCSR) {
    (function (win) {
        "use strict";
        
        var top         = Dom.window;
        
        var getQueryStr  = base.getQueryStr;
        var base64decode = encrypt.base64decode;
        var getKeyValue  = localstorage.getKeyValue;
    
        var _e           = {},
        _o               = {},
        _sUserAgent      = Dom.window.navigator.userAgent;
        
        _e.isiOS         = env.isiOS;
        _e.isAndroid     = env.isAndroid;
        _e.isWechat      = env.isWechat;
        _e.isiOS9        = env.isiOS9;
        _e.isPcWechat    = env.isPcWechat;
    
        (function (agent) {
            if (_e.isWechat) {
                var info            = agent.split('MicroMessenger/')[1];
                _o.networktype      = env.getNetworkType(info);           
                _o.clientversion    = env.clientVersion();
                _o.device = _e.isAndroid ? 'android' : (_e.isiOS ? 'iphone' : '0');
            }
            var f       = getQueryStr('from',null,top),
                fmap    = {
                    singlemessage   : 1,
                    groupmessage    : 2,
                    timeline        : 4,
                    message         : 10
                };
            if (f && f in fmap) {
                _o.sourcescene = fmap[f];
                fmap = null;
            }
            /*
            * @desc 如果是noticeid则先取 当前window下的，再取top上的。
            */
            var nid = getQueryStr('noticeid') || getQueryStr('noticeid',null,top);
            if (nid && nid.length > 1) {
                _o.noticeid = nid;
            } else {
                _o.noticeid = win.noticeid || win.nNoticeID || win.nNoticeId || 66043145;
            }
            /*
            * @desc 如果是actid 也是先取当前 window下的，再取top上的。
            */
            var actid =     getQueryStr('actid') 
                        || getQueryStr('actid',null,top) 
                        || getQueryStr('act_id')
                        || getQueryStr('act_id',null,top) 
                        || win.actid 
                        || win.iActID 
                        || win.iActId 
                        || 0;

            if (actid){_o.actid = actid;}
            var uin = base64decode(decodeURIComponent(getQueryStr('uin',null,top))) 
                        || getKeyValue('uin') || 0;
            if (uin){_o.uin = uin;}
            _e.reportObj    = _o;
            _e.imgReport    = imgReport;

            /**
             * 必须先深度拷贝一下。。。以支持一个页面，引入两个上报库。
             */
            var _aoExport = deepclone(_e,true);

            exportData = _aoExport;
        })(_sUserAgent);
        
        function imgReport(_sUrl) {
            // 遇到几次被QB(X5浏览器)误加了 @@@时间戳@@@ ，在这直接加&结尾，解决该问题 add by zijianyang 
            if(_sUrl.indexOf("?") !== -1){
                _sUrl += "&QB&";
            }else{
                _sUrl += "?&QB&";
            }
    
            try{
                /**获取  ？后面的东西。 */
    
                var query = StringUtil.getQuery(_sUrl);
                if( window.logWarn ){
                    logWarn('report_base','reportData:',query);
                }
            }catch (e) {
    
            }
            
            new Image(1, 1).src = _sUrl;
        }
    })(window);
}
export default exportData;
